const mainNavElement = document.querySelector('#main-navigation > ul');
const itemsToPosition = document.querySelectorAll('#main-navigation > ul > .openbox-container > .openbox-content > .container > nav');

function getRealContentWidth(flexContainer) {
  let totalWidth = 0;
  
  // Loop through all immediate children
  Array.from(flexContainer.children).forEach(child => {
    totalWidth += child.getBoundingClientRect().width;
  });
  
  return totalWidth;
}

// Usage inside your ResizeObserver
const topMenuObserver = new ResizeObserver(() => {
  // If the target element isn't found yet, exit early to prevent errors
  if (!mainNavElement) return;

  const contentWidth = getRealContentWidth(mainNavElement);
  document.documentElement.style.setProperty('--content-width', `${contentWidth}px`);
  // FIXED: Loop using standard forEach syntax
  /*
  itemsToPosition.forEach(item => {
    console.log('AAAAA:', item, '--content-width', `${contentWidth}px`);
    
    // Set the property directly on the element's style object
    item.style.setProperty('--content-width', `${contentWidth}px`);
  });
  */
});

// Safeguard in case the targetElement doesn't exist on the page
if (mainNavElement) {
  topMenuObserver.observe(mainNavElement);
}